export const defaultContextPermission = () => ({
  allowed_roles: [],
  allowed_campaigns: [],
  allowed_client_type: 0,
  allowed_customer_groups: [],
  allowed_groups: [],
  preonboarded: 0,
})

export const normalizeContextPermission = (contextPermission) => ({
  allowed_roles: contextPermission?.allowed_roles || [],
  allowed_campaigns: contextPermission?.allowed_campaigns || [],
  allowed_client_type: parseInt(contextPermission?.allowed_client_type ?? 0, 10),
  allowed_customer_groups: contextPermission?.allowed_customer_groups || [],
  allowed_groups: contextPermission?.allowed_groups || [],
  preonboarded: parseInt(contextPermission?.preonboarded ?? 0, 10),
})

export const toContextPermissionPayload = (contextPermission) => ({
  groups: contextPermission.allowed_groups,
  roles: contextPermission.allowed_roles,
  customer_groups: contextPermission.allowed_customer_groups,
  campaigns: contextPermission.allowed_campaigns,
  client_type: parseInt(contextPermission.allowed_client_type ?? 0, 10),
  preonboarded: parseInt(contextPermission.preonboarded ?? 0, 10),
})

export const selectOptionLabel = (label, locale) => {
  if (typeof label === 'string') return label
  if (label && typeof label === 'object') {
    return (locale && label[locale]) || Object.values(label).find((value) => value) || ''
  }
  return ''
}

export const mapCampaignSelectOptions = (campaigns, locale) =>
  (campaigns ?? []).map((campaign) => ({
    value: campaign.value,
    label: selectOptionLabel(campaign.label, locale),
  }))

export const appendContextPermission = (payload, contextPermission) => {
  payload.context_permission = toContextPermissionPayload(
    normalizeContextPermission(contextPermission),
  )
  return payload
}

/** @deprecated Local-app save still uses appendContextPermission. Global apps must not send context_permission. */
export const appendContextPermissionIfVisible = (payload, isVisibleEveryone, contextPermission) => {
  if (isVisibleEveryone) {
    appendContextPermission(payload, contextPermission)
  }
  return payload
}
